export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7125.88074e42.jpg";